;(function() {
  'use strict'

  config.$inject = ["$stateProvider"];
  angular.module('app.core').config(config)

  /* @ngInject */
  function config($stateProvider) {
    $stateProvider.state('estimate', {
      url: '/estimate',
      parent: 'portal',
      templateUrl: 'estimate.html',
      controller: 'Estimate',
      controllerAs: '$ctrl',
      title: 'Get an estimate',
      public: true,
    })

    $stateProvider.state('studio-estimate-deprecated', {
      url: '/studio/estimate',
      redirectTo: 'estimate',
    })
  }
})()
